import clsx from 'clsx';
import type { FormLocale } from '@jlg-website/shared';
import { textFor } from '../shared/copy';

type ContinueButtonProps = {
  disabled: boolean;
  locale: FormLocale;
  onClick: () => void;
};

export function ContinueButton({ disabled, locale, onClick }: ContinueButtonProps) {
  return (
    <button
      type="button"
      disabled={disabled}
      onClick={onClick}
      className={clsx(
        'brand-button w-full py-3.5 text-sm',
        disabled ? 'bg-brand-muted-light text-gray-light' : 'bg-brand-primary text-white'
      )}
    >
      {textFor(locale, 'continue')}
    </button>
  );
}
